exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-custom-tag-input .b-form-tag {\n  background-color: #01b1af !important;\n  color: #fff !important;\n  border-radius: 3px !important;\n  align-items: center !important;\n  margin-top: 5px !important;\n  margin-left: 5px !important;\n  font-size: 14px !important;\n  padding: 5px 7px !important;\n}\n.email-custom-tag-input .b-form-tag .close {\n  font-size: 1.1rem !important;\n  font-weight: 400 !important;\n  line-height: unset !important;\n  color: #000 !important;\n  margin-left: 5px !important;\n}\n", ""]);

// exports
